export const errors = {
  463: 'El id de la orden ya existe, por favor elije otro id',
  'You are paying more than the total':
    'Se está tratando de pagar más del total de la orden, por favor ingrese una cantidad válida',
};
